import React from 'react'
import GlobalCss from 'gatsby-theme-directv/src/components/CustomStyles/GlobalCss.styles'
import { withTheme } from '@emotion/react'

const GlobalStyles = withTheme(() => (
  <>
    <GlobalCss />
  </>
))

export default GlobalStyles
